import React from 'react';
import { Route } from 'react-router-dom';
import { tabList } from './NavBarConfig';
import { pageRoutes } from './PageConfig';
import { rewritePermission } from '../utils';
import NoPermission from '../containers/base/NoPermission';
import { PermissionCodes } from './PermissionCodes';
import CustomerList from 'containers/customers/customer/CustomerList';
import { getUserPermissions } from 'models/UsersModel';

function Authorization(route, user) {
  let userPermissions = user.userPermissions;
  if (!user.startUpDone) {
    userPermissions = getUserPermissions();
  };
  const newPermission = rewritePermission(route?.codename);
  if (user.isSuperuser) return route.main;
  if (userPermissions?.includes(newPermission) || !newPermission) {
    return route.main;
  }
  if(route?.codenames && route.codenames.some((code) => userPermissions.includes(code))){
    return route.main;
  }
  // console.log("@@22: ", newPermission, user)
  if (
    (newPermission.indexOf('_') < 0 &&
      [
        PermissionCodes.customer,
        PermissionCodes.campaign,
        PermissionCodes.coupontemplate,
      ].includes(newPermission)) ||
    userPermissions.filter((val) => val.split('_')[1] === newPermission)
      .length > 0
  ) {
    return route.main;
  }

  return <NoPermission />;
}

function getOneRouteElement(route, user) {
  if (route.path == "/"){
    if (!user?.hasDashboardPermission) {
      const route_customer = {
        path: '/',
        name: 'Home',
        exact: true,
        main: () => <CustomerList />
      }
      return (
        <Route
          key={route_customer.path}
          path={route_customer.path}
          exact={route_customer.exact}
          children={Authorization(route_customer, user)}
        />
      ); 
    }   
  }
  return (
    <Route
      key={route.path}
      path={route.path}
      exact={route.exact}
      children={Authorization(route, user)}
    />
  );
}
function getNavBarRoutes(user) {
  const routeLists = [];
  tabList.forEach((tab, index) => {
    if (tab.list) {
      tab.list.forEach((route, index) => {
        if (route.children) {
          route.children.forEach((child, index) => {
            const routeElement = getOneRouteElement(child, user);
            routeLists.push(routeElement);
          });
        } else {
          const routeElement = getOneRouteElement(route, user);
          routeLists.push(routeElement);
        }
      });
    }
  });

  return routeLists;
}
function getPageRoutes(user) {
  return pageRoutes.map((route) => getOneRouteElement(route, user));
}
const routes = (user) => [...getNavBarRoutes(user), ...getPageRoutes(user)];
export default routes;
